import { Menu, MenuButton, MenuItem, MenuList, Flex } from "@chakra-ui/react";
import { GoKebabVertical } from "react-icons/go";

function KebabMenu({
  onEdit,
  onDelete,
  extraActions,
}: {
  onEdit?: () => any;
  onDelete?: () => any;
  extraActions?: {
    label: string;
    onClick: () => any;
  }[];
}) {
  if (!onEdit && !onDelete && !extraActions?.length) {
    return null;
  }

  return (
    <Menu>
      <MenuButton onClick={(ev) => ev.stopPropagation()}>
        <Flex
          bg="gray.100"
          rounded="full"
          justifyContent="center"
          alignItems="center"
          w={"25px"}
          h="25px"
          _hover={{
            bg: "gray",
          }}
        >
          <GoKebabVertical />
        </Flex>
      </MenuButton>
      <MenuList>
        {onEdit ? (
          <MenuItem
            fontSize="14px"
            onClick={(ev) => {
              ev.stopPropagation();
              onEdit?.();
            }}
          >
            Editar
          </MenuItem>
        ) : null}
        {extraActions?.map((action, index) => (
          <MenuItem
            fontSize="14px"
            onClick={(ev) => {
              ev.stopPropagation();
              action.onClick();
            }}
            key={index}
          >
            {action.label}
          </MenuItem>
        ))}
        {onDelete ? (
          <MenuItem
            fontSize="14px"
            onClick={(ev) => {
              ev.stopPropagation();
              onDelete?.();
            }}
          >
            Excluir
          </MenuItem>
        ) : null}
      </MenuList>
    </Menu>
  );
}

export default KebabMenu;
